/**
 * @class RefillValidation
 */
export default class RefillValidation {
    /**
     * @param {Number}  canisterIndex
     * @param {Object}  canister
     * @param {Object}  colorantPackage
     */
    constructor(canisterIndex, canister = null, colorantPackage = null) {
        this._canisterIndex = canisterIndex;
        this._canister = canister;
        this._colorantPackage = colorantPackage;
    }

    /**
     * @return {Number}
     */
    get canisterIndex() {
        return this._canisterIndex;
    }

    /**
     * @param {Number} canisterIndex
     */
    set canisterIndex(canisterIndex) {
        this._canisterIndex = canisterIndex;
    }

    /**
     * @return {Number}
     */
    get canister() {
        return this._canister;
    }

    /**
     * @param {Number} canister
     */
    set canister(canister) {
        this._canister = canister;
    }

    /**
     * @return {Number}
     */
    get colorantPackage() {
        return this._colorantPackage;
    }

    /**
     * @param {Number} colorantPackage
     */
    set colorantPackage(colorantPackage) {
        this._colorantPackage = colorantPackage;
    }

    /**
     * @return {String}
     */
    toString() {
        return "RefillValidation (" + this._canisterIndex + ")";
    }

    /**
     * @return {Boolean}
     */
    isCanisterValid() {
        if (this._canister === null || this._canister.colorant === null) {
            return false;
        }

        if (this._canister.id < 1) {
            return false;
        }

        return this._canisterIndex === this._canister.id;
    }

    /**
     * @return {Boolean}
     */
    isValid() {
        if (this._canister === null || this._canister.colorant === null) {
            return false;
        }

        if (this._canister.id < 1 || this._canister.id !== this._canisterIndex) {
            return false;
        }

        if (this._colorantPackage === null || this._colorantPackage.id < 1) {
            return false;
        }

        return this._canister.colorant.name === this._colorantPackage.colorantName;
    }

    /**
     * @return {Boolean}
     */
    isEnoughSpace() {
        if (!this.isValid()) {
            return false;
        }

        if (this._canister.currentLevelMl + this._colorantPackage.fillingMl > this._canister.capacityMl) {
            return false;
        }

        return true;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new RefillValidation(this._canisterIndex, this._canister, this._colorantPackage);
    }

    /**
     * Resets properties.
     *
     * @return  {Object}
     */
    reset = () => {
        return new RefillValidation(this._canisterIndex);
    };

    /**
     * Resets colorant package property.
     *
     * @return  {Object}
     */
    resetColorantPackage = () => {
        return new RefillValidation(this._canisterIndex, this._canister, null);
    };

    /**
     * Clones validation object and updates canisterIndex property.
     *
     * @param   {Number} canisterIndex
     * @return  {Object}
     */
    updateCanisterIndex = (canisterIndex) => {
        let validation = this.clone();
        validation.canisterIndex = canisterIndex;
        validation.canister = null;
        validation.colorantPackage = null;

        return validation;
    };

    /**
     * Clones validation object and updates canister property.
     *
     * @param   {Object} canister
     * @return  {Object}
     */
    updateCanister = (canister) => {
        let validation = this.clone();
        validation.canister = canister;

        return validation;
    };

    /**
     * Clones validation object and updates colorantPackage property.
     *
     * @param   {Object} colorantPackage
     * @return  {Object}
     */
    updateColorantPackage = (colorantPackage) => {
        let validation = this.clone();
        validation.colorantPackage = colorantPackage;

        return validation;
    };
}
